module.exports = __webpack_public_path__ + "img/image21.af255861.png";